export const CELL_MODE_DATA_ATTRIBUTE_KEY = "data-cell-mode";

export const cellMode = {
  SELECT: "select",
  EDIT: "edit",
  UPDATE: "update"
};
